import React from "react";
import connectRecord from "./connectRecord";

/* Use this to automatically fetch a record when your component
 * mounts if the record is not already at the specified location
 * in the store. This decorator relies on a convention where the
 * assuming that the name of the reducer will match the name of the
 * property that identifies the record. It also assumes that your
 * component is being rendered with react-router, and that the route
 * contains an id parameter identifying the record to be fetched.
 */
export default function loadRecord(options) {
  const Container = connectRecord(options);

  return Component => props => (
    <Container {...props}>
      <Component {...props} />
    </Container>
  );
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/loadRecord.jsx